customElements.get("recipient-form") ||
  customElements.define(
    "recipient-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.recipientFieldsLiveRegion = this.querySelector(
            "#Recipient-fields-live-region"
          )),
          (this.checkboxInput = this.querySelector("#Recipient-checkbox")),
          (this.checkboxInput.disabled = !1),
          (this.hiddenControlField = this.querySelector("#Recipient-control")),
          (this.hiddenControlField.disabled = !0),
          (this.recipientFields = this.querySelector("#Recipient-field")),
          (this.emailInput = this.querySelector("#Recipient-email")),
          (this.nameInput = this.querySelector("#Recipient-name")),
          (this.messageInput = this.querySelector("#Recipient-message")),
          (this.sendonInput = this.querySelector("#Recipient-send-on")),
          (this.offsetProperty = this.querySelector(
            "#Recipient-timezone-offset"
          )),
          this.offsetProperty &&
            (this.offsetProperty.value = new Date()
              .getTimezoneOffset()
              .toString()),
          (this.errorMessageWrapper = this.querySelector(
            ".product-form__recipient-error-message-wrapper"
          )),
          (this.errorMessageList =
            this.errorMessageWrapper?.querySelector("ul")),
          (this.errorMessage =
            this.errorMessageWrapper?.querySelector(".error-message")),
          (this.defaultErrorHeader = this.errorMessage?.innerText),
          (this.currentProductVariantId = this.dataset.productVariantId),
          this.addEventListener("change", this.onChange.bind(this)),
          this.onChange();
      }
      cartUpdateUnsubscriber = void 0;
      variantChangeUnsubscriber = void 0;
      cartErrorUnsubscriber = void 0;
      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
          this.variantChangeUnsubscriber && this.variantChangeUnsubscriber(),
          this.cartErrorUnsubscriber && this.cartErrorUnsubscriber();
      }
      onChange() {
        this.checkboxInput.checked
          ? (this.enableInputFields(),
            this.recipientFields.classList.add("recipientActive"))
          : (this.clearInputFields(),
            this.disableInputFields(),
            this.clearErrorMessage(),
            this.recipientFields.classList.remove("recipientActive"));
      }
      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput,
        ];
      }
      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }
      clearInputFields() {
        this.inputFields().forEach((e) => (e.value = ""));
      }
      enableInputFields() {
        this.disableableFields().forEach((e) => (e.disabled = !1));
      }
      disableInputFields() {
        this.disableableFields().forEach((e) => (e.disabled = !0));
      }
      displayErrorMessage(e, r) {
        if (
          (this.clearErrorMessage(),
          (this.errorMessageWrapper.hidden = !1),
          "object" == typeof r)
        )
          return (
            (this.errorMessage.innerText = this.defaultErrorHeader),
            Object.entries(r).forEach(([e, r]) => {
              const t = `RecipientForm-${e}-error`,
                s = `#Recipient-${e}`,
                i = `${r.join(", ")}`,
                n = this.querySelector(`#${t}`),
                a = n?.querySelector(".error-message");
              if (!a) return;
              this.errorMessageList &&
                this.errorMessageList.appendChild(
                  this.createErrorListItem(s, i)
                ),
                (a.innerText = `${i}.`),
                n.classList.remove("hidden");
              const c = this[`${e}Input`];
              c &&
                (c.setAttribute("aria-invalid", !0),
                c.setAttribute("aria-describedby", t));
            })
          );
        this.errorMessage.innerText = r;
      }
      createErrorListItem(e, r) {
        const t = document.createElement("li"),
          s = document.createElement("a");
        return (
          s.setAttribute("href", e),
          (s.innerText = r),
          t.appendChild(s),
          (t.className = "error-message"),
          t
        );
      }
      clearErrorMessage() {
        (this.errorMessageWrapper.hidden = !0),
          this.errorMessageList && (this.errorMessageList.innerHTML = ""),
          this.querySelectorAll(".recipient-fields .form__message").forEach(
            (e) => {
              e.classList.add("hidden");
              const r = e.querySelector(".error-message");
              r && (r.innerText = "");
            }
          ),
          [
            this.emailInput,
            this.messageInput,
            this.nameInput,
            this.sendonInput,
          ].forEach((e) => {
            e.setAttribute("aria-invalid", !1),
              e.removeAttribute("aria-describedby");
          });
      }
      resetRecipientForm() {
        this.checkboxInput.checked &&
          ((this.checkboxInput.checked = !1),
          this.clearInputFields(),
          this.clearErrorMessage());
      }
    }
  );
